import Crud from '../views/City/Crud'
import Entity from '../views/City/Add'

let routes = {
    path: '/cities',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cities/add',
            name: 'Newcity',
            component: Entity,
            meta: {
                pageTitle: 'Cidade',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Cidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cities/edit/:id?',
            name: 'Editcity',
            component: Entity,
            meta: {
                pageTitle: 'Cidade',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Cidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cities',
            name: 'list-cities',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Cidades',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Cidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
